'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { SupportClock } from './SupportClock';
import styles from './SupportDemo.module.css';

const messages = [
    { type: 'support', text: 'Здравствуйте! Чем могу помочь?', time: '12:01' },
    { type: 'user', text: 'Добрый день! Подскажите, как отследить посылку?', time: '12:02' },
    {
        type: 'support',
        text: 'Конечно! Введите трек-номер в поле ниже, и я помогу узнать статус вашей посылки.',
        time: '12:02',
    },
    { type: 'user', text: '900123456789', time: '12:03' },
];

export const SupportDemo = () => {
    /*
    const [isTyping, setIsTyping] = React.useState(false);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setIsTyping((prev) => !prev);
        }, 3000);

        return () => clearInterval(timer);
    }, []);
*/

    return (
        <motion.div
            className={styles.container}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.userInfo}>
                    <div className={styles.iconWrapper}>
                        <MessageCircle className={styles.icon} />
                    </div>
                    <div>
                        <h3 className={styles.userName}>Поддержка CDEK</h3>
                        <div className={styles.status}>
                            <div className={styles.onlineDot} />
                            <span className={styles.statusText}>Онлайн</span>
                        </div>
                    </div>
                </div>
                <SupportClock />
            </div>

            {/* Chat Area */}
            <div className={styles.chatArea}>
                <div className={styles.messagesContainer}>
                    {messages.map((message, index) => (
                        <motion.div
                            key={index}
                            className={`${styles.messageRow} ${message.type === 'user' ? styles.userRow : styles.supportRow}`}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.15 }}
                        >
                            <div
                                className={`${styles.messageBubble} ${
                                    message.type === 'user'
                                        ? styles.userBubble
                                        : styles.supportBubble
                                }`}
                            >
                                <div className={styles.messageText}>{message.text}</div>
                                <div className={styles.messageTime}>{message.time}</div>
                            </div>
                        </motion.div>
                    ))}

                    <motion.div
                        className={`${styles.messageRow} ${styles.supportRow}`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        <div className={`${styles.messageBubble} ${styles.supportBubble}`}>
                            <div className={styles.typingIndicator}>
                                <div
                                    className={styles.typingDot}
                                    style={{ animationDelay: '0ms' }}
                                />
                                <div
                                    className={styles.typingDot}
                                    style={{ animationDelay: '150ms' }}
                                />
                                <div
                                    className={styles.typingDot}
                                    style={{ animationDelay: '300ms' }}
                                />
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Input Field */}
            <div className={styles.inputWrapper}>
                <div className={styles.fakeInput}>Демонстрационный режим</div>
                <button className={styles.sendButton} disabled>
                    <MessageCircle className={styles.sendIcon} />
                </button>
            </div>

            {/* Footer Stats */}
            <div className={styles.footerStats}>
                <div>Среднее время ответа: 30 сек</div>
                <div>97% довольных клиентов</div>
            </div>
        </motion.div>
    );
};
